import { render, staticRenderFns } from "./bookDetails.vue?vue&type=template&id=4e2b2e36&scoped=true"
import script from "./bookDetails.vue?vue&type=script&lang=js"
export * from "./bookDetails.vue?vue&type=script&lang=js"
import style0 from "./bookDetails.vue?vue&type=style&index=0&id=4e2b2e36&prod&lang=less&scoped=true"
import style1 from "./bookDetails.vue?vue&type=style&index=1&id=4e2b2e36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b2e36",
  null
  
)

export default component.exports